var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "76px",
    viewBox: "0 0 95 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "77.1758805%",
    cy: "25.7379553%",
    fx: "77.1758805%",
    fy: "25.7379553%",
    r: "91.1819884%",
    gradientTransform: "translate(0.771759,0.257380),scale(1.000000,0.853213),rotate(107.339919),translate(-0.771759,-0.257380)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.89743889e-07%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084C8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1572CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(-785.000000, -4162.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(785.760579, 4162.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1236212,20.9982686 C56.9201217,19.7196146 61.496804,17.831602 64.8442121,15.3342308 L64.8442121,64.5820189 C64.8442121,66.634858 63.392723,68.5378549 60.4944727,70.2910095 C57.5962225,72.044164 53.6578172,73.4376972 48.6745289,74.4616193 C43.6959685,75.4855415 38.2777062,76 32.42447,76 C26.5712338,76 21.1529716,75.4855415 16.1696832,74.4616193 C11.1863949,73.4376972 7.24798958,72.044164 4.34973934,70.2910095 C1.45148911,68.5378549 0,66.634858 0,64.5820189 L0,15.3342308 C3.3474081,17.831602 7.92409037,19.7196146 13.7205908,20.9982686 C17.5880765,21.8507047 23.8227029,22.4900317 32.42447,22.9162497 C41.0262372,22.4900317 47.2592876,21.8507047 51.1236212,20.9982686 Z M32.422106,0 C38.2749155,0 43.6927827,0.503664889 48.6757078,1.50610472 C53.6586328,2.50854454 57.5967509,3.8728407 60.4947899,5.58921328 C63.3928288,7.30558587 64.8442121,9.16865696 64.8442121,11.1784266 L64.8442121,16.7676399 C64.8442121,18.7774095 63.3928288,20.6404806 60.4947899,22.3568531 C57.5967509,24.0732257 53.6586328,25.4326319 48.6757078,26.4399617 C43.6927827,27.4424015 38.2749155,27.9411765 32.422106,27.9411765 C26.5692966,27.9411765 21.1514293,27.4375116 16.1685043,26.4350718 C11.1855793,25.4326319 7.24746115,24.0683358 4.34942222,22.3519632 C1.45138328,20.6355906 0,18.7725195 0,16.7627499 L0,11.1784266 C0,9.16865696 1.45138328,7.30558587 4.34942222,5.58921328 C7.24746115,3.8728407 11.1855793,2.50854454 16.1685043,1.50610472 C21.1514293,0.503664889 26.5692966,0 32.422106,0 L32.422106,0 L32.422106,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4206709,67.6875001 L29.0519209,67.6875001 L29.0519209,54.31875 C26.4644209,49.575 24.7394209,43.5375 24.7394209,37.5 C24.7394209,18.525 40.264421,3 59.2394209,3 C78.2144209,3 93.7394209,18.525 93.7394209,37.5 C93.7394209,56.475 78.2144209,72 59.2394209,72 C53.201921,72 47.5956709,70.275 42.4206709,67.6875001 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature-3.09b30f93366c3988db2f00aa9a8640e5.svg";
export { ForwardRef as ReactComponent };